import axios from 'axios'
import { requestInterceptor, responseInterceptor, errorInterceptor, resetRefreshState } from './interceptors'

export { resetRefreshState }

export const getApiBaseUrl = (): string => {
  const envUrl = import.meta.env.VITE_API_BASE_URL
  if (envUrl && envUrl.trim() !== '') {
    return envUrl.trim().replace(/\/+$/, '')
  }
  return 'http://api.ledryt.com'
}

const apiClient = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',
  },
})

// Register Axios Interceptors
apiClient.interceptors.request.use(requestInterceptor)
apiClient.interceptors.response.use(responseInterceptor, errorInterceptor)

export default apiClient
